<template>
    <div class="contentElement__front">
        <h3 class="contentElement__frontTitle">
            {{ title }}
        </h3>
        <p class="contentElement__frontIntro">
            {{ introduction }}
        </p>
        <Ticker :side="'front'" />
        <div class="contentElement__gradientBackgrounds">
            <div
                v-for="word in countInWords"
                :key="word"
                class="contentElement__gradientBackground"
                :class="`-${word}`"
            />
        </div>
        <Icon :side="'front'" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Icon from './Icon'
import Ticker from './Ticker'

export default {

    components: {
        Icon,
        Ticker,
    },

    props: {
        title: {
            type: String,
            required: true,
        },
        introduction: {
            type: String,
            required: true,
        },
    },

    computed: {
        ...mapGetters(['keyedData']),

        countInWords () {
            return Object.keys(this.keyedData).map(key => key)
        },
    },

}
</script>
